import * as React from "react"
import styled from "styled-components"
import { Line } from "../../interfaces/SaleorTypes"
import { getFormattedPrice } from "../../../utils/cart-helpers"
import H4 from "../../atoms/typography/H4"
import BodyMedium from "../../atoms/typography/BodyMedium"
import BodyLarge from "../../atoms/typography/BodyLarge"

interface ConfirmationItemCardProps {
  line: Line
  status: String
  amountOfRentalTerminals?: number
}

const ConfirmationItemCardContainer = styled.div`
  margin: 1em 0;
`

const ConfirmationItemCardRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1em 0;
`

const ConfirmationItemCardData = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
`

const ProductContainer = styled.div`
  display: flex;
  flex-direction: row;
`

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1.25em;
`
const ImageWrapper = styled.div`
  display: flex;
  min-width: 100px;
  justify-content: center;
  align-items: center;
`

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const InfoTitleContainer = styled.div``

const InfoDescContainer = styled.div``

const QuantityContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

const PriceContainer = styled.div`
  display: flex;
  justify-content: center;
`

const ConfirmationItemCard: React.FunctionComponent<ConfirmationItemCardProps> = ({ line, status, ...props }) => {
  return (
    <ConfirmationItemCardContainer>
      <ConfirmationItemCardRow>
        <ProductContainer>
          {line?.variant?.product?.media &&
            line?.variant?.product?.media?.length > 0 &&
            line?.variant?.product?.media[0]?.url && (
              <ImageContainer>
                <ImageWrapper>
                  <img src={line?.variant?.product?.media[0]?.url} height={100} />
                </ImageWrapper>
              </ImageContainer>
            )}
          <InfoContainer>
            <InfoTitleContainer>
              <H4>{line.variant.product?.name}</H4>
            </InfoTitleContainer>
            {line.variant.product?.description && (
              <InfoDescContainer>
                <BodyMedium>{JSON.parse(line.variant.product?.description)?.blocks[0]?.data?.text}</BodyMedium>
              </InfoDescContainer>
            )}
          </InfoContainer>
        </ProductContainer>
      </ConfirmationItemCardRow>
      <ConfirmationItemCardRow>
        <BodyMedium>Quantity:</BodyMedium>
        <ConfirmationItemCardData>
          <QuantityContainer>
            {line.variant.product?.category.name === "Topups" ? (
              <BodyLarge textAlign="center">{line.variant.name}</BodyLarge>
            ) : (
              <BodyLarge textAlign="center">{line.quantity}</BodyLarge>
            )}
          </QuantityContainer>
        </ConfirmationItemCardData>
      </ConfirmationItemCardRow>
      <ConfirmationItemCardRow>
        <BodyMedium>Price:</BodyMedium>
        <ConfirmationItemCardData>
          <PriceContainer>
            <BodyMedium>
              {status == "UNCONFIRMED"
                ? "TBD"
                : getFormattedPrice(line.totalPrice.gross.amount, line.totalPrice.gross.currency)}
            </BodyMedium>
          </PriceContainer>
        </ConfirmationItemCardData>
      </ConfirmationItemCardRow>
    </ConfirmationItemCardContainer>
  )
}

export default ConfirmationItemCard
